if (!customElements.get('ecpr-complete-package')) {
  customElements.define(
    'ecpr-complete-package',
    class ECPRCompletePackage extends HTMLElement {
      constructor() {
        super();

        this.items = [...this.querySelectorAll('[data-ecpr-package-item]')];
        this.button = this.querySelector('[data-ecpr-package-submit]');
        this.buttonLabel = this.querySelector('[data-ecpr-package-button-label]');
        this.total = this.querySelector('[data-ecpr-package-total]');
        this.status = this.querySelector('[data-ecpr-package-status]');
        this.spinner = this.querySelector('.button-overlay-spinner');

        this.addEventListener('change', this.onChange.bind(this));
        this.button?.addEventListener('click', this.onSubmit.bind(this));
        this.update();
      }

      get selectedItems() {
        return this.items.filter((item) => {
          const checkbox = item.querySelector('[data-ecpr-package-checkbox]');
          return checkbox?.checked;
        });
      }

      onChange(event) {
        if (!event.target.matches('[data-ecpr-package-checkbox]')) return;
        this.update();
      }

      update() {
        this.items.forEach((item) => {
          const checkbox = item.querySelector('[data-ecpr-package-checkbox]');

          if (item.dataset.required === 'true' && checkbox) {
            checkbox.checked = true;
          }

          item.classList.toggle('is-selected', Boolean(checkbox?.checked));
        });

        const selectedItems = this.selectedItems;
        const totalCents = selectedItems.reduce(
          (sum, item) => sum + Number.parseInt(item.dataset.priceCents || '0', 10),
          0,
        );

        if (this.total) {
          this.total.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
            style: 'currency',
            currency: this.dataset.currencyCode || 'USD',
          }).format(totalCents / 100);
        }

        if (this.buttonLabel) {
          this.buttonLabel.textContent =
            selectedItems.length > 1 ? this.dataset.fullLabel : this.dataset.singleLabel;
        }

        if (this.button) {
          this.button.disabled = selectedItems.length === 0;
        }

        if (this.status) this.status.textContent = '';
      }

      async onSubmit() {
        if (!this.button || this.button.getAttribute('aria-busy') === 'true') return;

        const items = this.selectedItems.map((item) => ({
          id: Number(item.dataset.variantId),
          quantity: 1,
        }));

        if (items.length === 0) return;

        const miniCart = document.querySelector('mini-cart');
        const sections = miniCart?.getSectionsToRender?.().map((section) => section.section) || [];
        const defaultLabel = this.buttonLabel?.textContent || this.dataset.fullLabel;

        this.button.setAttribute('aria-busy', 'true');
        this.button.setAttribute('aria-disabled', 'true');
        this.spinner?.classList.remove('hidden');
        if (this.status) this.status.textContent = '';

        const config = fetchConfig();
        config.body = JSON.stringify({
          items,
          sections,
          sections_url: window.location.pathname,
        });

        try {
          const response = await fetch(routes.cart_add_url, config);
          const parsedState = await response.json();

          if (!response.ok || parsedState.status) {
            throw new Error(parsedState.description || this.dataset.errorMessage);
          }

          if (miniCart) {
            miniCart.renderContents(parsedState);

            if (window.themeSettings.redirectToCart) {
              window.location.href = window.routes.cart_url;
            } else {
              miniCart.open(this.button);
            }
          } else {
            window.location.href = window.routes.cart_url;
          }

          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartItemAdd, {
              source: 'ECPRCompletePackage',
              items: parsedState.items || [],
            });
          }

          if (this.buttonLabel) this.buttonLabel.textContent = this.dataset.successLabel;
          if (this.status) this.status.textContent = this.dataset.successLabel;
        } catch (error) {
          const message = error.message || this.dataset.errorMessage;
          if (this.status) this.status.textContent = message;
          miniCart?.setError?.(message);
        } finally {
          this.spinner?.classList.add('hidden');
          this.button.removeAttribute('aria-busy');
          this.button.removeAttribute('aria-disabled');

          window.setTimeout(() => {
            if (this.buttonLabel) this.buttonLabel.textContent = defaultLabel;
          }, 1800);
        }
      }
    },
  );
}
